import { z } from 'zod';
import { questSchema } from './common';
const recommendedQuestSchema = questSchema.merge(z.object({
    communityImageUrl: z.string().nullable(),
    communityName: z.string(),
    subdomain: z.string(),
    categoryId: z.string(),
}));
export const listRecommendedQuestsOutputSchema = z.object({
    results: z.array(recommendedQuestSchema),
    nextPage: z.number(),
    hasNextPage: z.boolean(),
    totalQuests: z.number(),
});
